import { useAutoAnimateConditional } from '@/hooks/useAutoAnimateConditional';
import { Section } from '../Section';
import CheckBox from '../core/Checkbox';
import { DeliveryMethod } from '@/types/offering';

export const DeliveryOption = ({
  wantedValue,
  value,
  onChange,
  title,
  children,
  disabled,
}: {
  wantedValue: DeliveryMethod;
  value: DeliveryMethod;
  onChange: (value: DeliveryMethod) => void;
  title: string;
  children: React.ReactNode;
  disabled?: boolean;
}) => {
  const selected = value === wantedValue;

  const [ref] = useAutoAnimateConditional<HTMLDivElement>();

  if (disabled) {
    return null;
  }

  return (
    <Section ref={ref} className="gap-4 !p-5">
      <CheckBox
        id={title}
        label={title}
        checked={selected}
        onClick={() => onChange(wantedValue)}
        className="-mt-0.5 size-6 rounded-full"
      />
      {selected && children}
    </Section>
  );
};
